import React from 'react';
import { InputText } from 'primereact/inputtext';

const InputFieldText = ({ value, onChange, label, errorMessage }) => {
  return (
    <div className="flex flex-column gap-2">
       <InputText value={value} onChange={onChange} invalid={errorMessage} placeholder={label} />
      {errorMessage && 
        <small id="text-help">
          {errorMessage}
        </small>}
    </div>
  );
};

export default InputFieldText;
